import React from 'react';
import { Button, KIND } from 'baseui/button';
import { HeadingSmall } from 'baseui/typography';

interface ConfirmationModalProps {
  isOpen: boolean;
  title?: string;
  message?: string;
  onConfirm: () => void;
  onCancel: () => void;
  confirmText?: string;
  cancelText?: string;
}

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  title = "Please confirm Status Change",
  message,
  onConfirm,
  onCancel,
  confirmText = "Confirm",
  cancelText = "Cancel"
}) => {
  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '32px',
        borderRadius: '12px',
        minWidth: '400px',
        maxWidth: '500px',
        textAlign: 'center',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)'
      }}>
        <HeadingSmall style={{ 
          margin: '0 0 16px 0', 
          fontSize: '18px',
          fontWeight: '600',
          color: '#333'
        }}>
          {title}
        </HeadingSmall>
        
        {message && (
          <p style={{ 
            margin: '0 0 24px 0', 
            fontSize: '14px',
            color: '#666',
            lineHeight: '1.5'
          }}>
            {message}
          </p>
        )}
        
        <div style={{ 
          display: 'flex', 
          gap: '12px', 
          justifyContent: 'center',
          marginTop: '24px'
        }}>
          <Button
            kind={KIND.secondary}
            onClick={onCancel}
            size="compact"
            overrides={{
              BaseButton: {
                style: {
                  minWidth: '100px',
                  height: '36px',
                  borderRadius: '6px',
                  fontSize: '14px',
                  fontWeight: '500'
                }
              }
            }}
          >
            {cancelText}
          </Button>
          <Button
            kind={KIND.primary}
            onClick={onConfirm}
            size="compact"
            overrides={{
              BaseButton: {
                style: {
                  minWidth: '100px',
                  height: '36px',
                  borderRadius: '6px',
                  fontSize: '14px',
                  fontWeight: '500',
                  backgroundColor: 'var(--tenant-primary, #000000)',
                  color: '#FFFFFF',
                  ':hover': {
                    backgroundColor: 'color-mix(in srgb, var(--tenant-primary, #000000) 85%, black)'
                  }
                }
              }
            }}
          >
            {confirmText}
          </Button>
        </div>
      </div>
    </div>
  );
};
